import { render, staticRenderFns } from "./permission-checkbox.vue?vue&type=template&id=4f03d7e7&scoped=true&"
import script from "./permission-checkbox.vue?vue&type=script&lang=js&"
export * from "./permission-checkbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f03d7e7",
  null
  
)

export default component.exports